import React from "react";

import classes from "./styles.module.scss";
import classNames from "classnames/bind";
const cx = classNames.bind(classes);

const Minesweeper = () => {
  return (
    <div className={cx("wrap")}>
      <h1>coming soon</h1>
    </div>
  );
};

export default Minesweeper;
